{
  "name": "@ns/update-public-ledger-topic-key",
  "version": "1.0.0",
  "description": "Change who signs the company's public ledger topic messages",
  "inputs": {
    "entityId": {
      "type": "string"
    },
    "type": {
      "type": "string"
    }
  },
  "outcomes": {
    "update": {},
    "cancel": {}
  },
  "jobMetadata": [
    "JOB_STATUS"
  ],
  "publicLedger": [
    {
      "id": "topic-signatory-change",
      "outcome": "update",
      "kind": "TOPIC_SIGNATORY_CHANGE"
    }
  ]
}
